import { Tooltip, IconButton } from "@upstart.gg/style-system/system";
import { IoIosHelpCircleOutline } from "react-icons/io";

export function HelpIcon({ help }: { help: string }) {
  return (
    <Tooltip content={<span className="text-xs block p-1">{help}</span>} className="!z-[10000]">
      <IconButton variant="ghost" size="3" radius="full" className="group !cursor-help !p-0 !mr-0.5">
        <IoIosHelpCircleOutline className="text-upstart-400 group-hover:text-upstart-600 h-[22px] w-[22px]" />
      </IconButton>
    </Tooltip>
  );
}
